export const UPS_EXPRESS = '07'
export const UPS_EXPRESS_SAVER = '65'
